<template>
  <div class="wineItemComponentForm">
    <div
      data-v-fae5bece
      class="v-card__title headline lighten-2 v-card__title--primary"
    >
      Vina
    </div>
    <v-form ref="form" v-model="valid" lazy-validation>
      <!--<v-layout row wrap>-->
      <!--<v-flex xs8>-->
      <!--<v-text-field-->
      <!--v-model="ID"-->
      <!--label="ID" readonly-->
      <!--&gt;</v-text-field>-->
      <!--</v-flex>-->
      <!--</v-layout> &lt;!&ndash; /.ID &ndash;&gt;-->

      <v-layout row wrap>
        <v-flex xs2 pa-2>
          <v-text-field
            v-model="godina"
            label="Godina"
            :rules="[(v) => !!v || 'Obavezan podatak']"
            required
            type="number"
          ></v-text-field>
        </v-flex>

        <v-flex xs4 pa-2>
          <v-autocomplete
            v-model="select"
            :items="wt_items"
            item-value="id"
            :item-text="getFieldText"
            :rules="[(v) => !!v || 'Obavezan podatak']"
            label="Etiketa - tip vina"
            required
            persistent-hint
            return-object
            ref="element1"
            v-on:change="getProizvodnja"
          ></v-autocomplete>
        </v-flex>
        <v-flex xs2 pa-2>
          <v-text-field
            v-model="alkohol"
            label="Alkohol (% vol.)"
            type="number"
            v-if="!proizvodnja"
          ></v-text-field>
        </v-flex>
        <v-flex xs2 pa-2>
          <v-text-field
            v-model="rezidualni_secer"
            label="Rezidualni šećer (g/l)"
            type="number"
            v-if="!proizvodnja"
          ></v-text-field>
        </v-flex>
        <v-flex xs2 pa-2>
          <v-text-field
            v-model="kiselina"
            label="Ukupno kiselina (g/l)"
            type="number"
            v-if="!proizvodnja"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <!-- /.Tank -->

      <v-layout row wrap>
        <v-flex xs2 pa-2>
          <v-text-field
            v-model="ph"
            label="PH vrednost"
            type="number"
            v-if="!proizvodnja"
          ></v-text-field>
        </v-flex>
        <v-flex xs2 pa-2>
          <v-text-field
            v-model="slobodni_sulfati"
            label="Slobodni SO2 (g/hl)"
            type="number"
            v-if="!proizvodnja"
          ></v-text-field>
        </v-flex>
        <v-flex xs2 pa-2>
          <v-text-field
            v-model="ukupni_sulfati"
            label="Ukupni SO2 (g/hl)"
            type="number"
            v-if="!proizvodnja"
          ></v-text-field>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs12 pa-2>
          <v-text-field v-model="opis" label="Opis"></v-text-field>
        </v-flex>
      </v-layout>
      <!-- /.Tank -->

      <v-layout row wrap>
        <v-flex xs12>
          <v-btn :disabled="!valid" @click="submit" class="AppButtonFilled"
            >Sačuvaj</v-btn
          >
          <v-btn @click="clear" class="AppButtonOutlined">odustani</v-btn>
        </v-flex>
      </v-layout>
      <!-- /.Action buttons -->
    </v-form>
    <TokenComponent ref="frmtoken" />
  </div>
</template>

<script>
import { serverBus } from "../main";
import { readJSON } from "../helpers/Functions";
import TokenComponent from "../components/Token";

export default {
  name: "WineItem",
  components: {
    TokenComponent,
  },
  data: () => ({
    valid: true,
    ID: "0",
    godina: 0,
    alkohol: undefined,
    rezidualni_secer: undefined,
    kiselina: undefined,
    ph: undefined,
    wt_items: [],
    select: "",
    opis: "",
    slobodni_sulfati: undefined,
    ukupni_sulfati: undefined,
    proizvodnja: false,
  }),
  methods: {
    getProizvodnja(e) {
      if (e !== undefined) this.proizvodnja = e.inProduction;
      else this.proizvodnja = false;
    },
    getFieldText(item) {
      return `${item.name} - ${item.wineType.name}`;
    },
    newSifarnik() {
      var complexObjectWineLabel = {
        id: this.select.id,
      };

      var complexObject = {
        year: this.godina,
        alcohol: this.alkohol,
        residualSugar: this.rezidualni_secer,
        totalAcid: this.kiselina,
        ph: this.ph,
        wineLabel: complexObjectWineLabel,
        description: this.opis,
        freeSulfates: this.slobodni_sulfati,
        totalSulfates: this.ukupni_sulfati,
      };

      //// // console.log(complexObject);

      this.$http
        .post(
          this.globalServiceLocation + this.globalPort + "/wine/create",
          complexObject,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          serverBus.$emit("refresh_wine");
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .post(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/wine/create",
                      complexObject,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      serverBus.$emit("refresh_wine");
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    changeSifarnik() {
      var complexObjectWineLabel = {
        id: this.select.id,
      };

      var complexObject = {
        id: this.ID,
        year: this.godina,
        alcohol: this.alkohol,
        residualSugar: this.rezidualni_secer,
        totalAcid: this.kiselina,
        ph: this.ph,
        wineLabel: complexObjectWineLabel,
        description: this.opis,
        freeSulfates: this.slobodni_sulfati,
        totalSulfates: this.ukupni_sulfati,
      };

      this.$http
        .put(
          this.globalServiceLocation +
            this.globalPort +
            "/wine/update/" +
            this.ID,
          complexObject,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          serverBus.$emit("refresh_wine");
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .put(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/wine/update/" +
                        this.ID,
                      complexObject,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      serverBus.$emit("refresh_wine");
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllEtikete() {
      this.$http
        .get(this.globalServiceLocation + this.globalPort + "/wine_label/all", {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer  " + localStorage.getItem("user-token"),
          },
        })

        .then((response) => {
          //// // console.log(response.data);

          this.wt_items = response.data;
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/wine_label/all",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      //// // console.log(response.data);

                      this.wt_items = response.data;
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    submit() {
      if (this.$refs.form.validate()) {
        if (this.ID != "" && this.ID != "0") {
          this.changeSifarnik();
        } else {
          this.newSifarnik();
        }

        this.clear();
      }
    },
    clear() {
      this.$refs.element1.reset();

      var d = new Date();
      this.godina = d.getFullYear();

      this.opis = undefined;

      this.ph = undefined;
      this.slobodni_sulfati = undefined;
      this.rezidualni_secer = undefined;
      this.alkohol = undefined;
      this.kiselina = undefined;
      this.ukupni_sulfati = undefined;

      this.ID = 0;
    },
  },
  mounted() {
    this.clear();
    var d = new Date();
    this.godina = d.getFullYear();

    this.getAllEtikete();

    serverBus.$on("applied_wine", (item) => {
      //alert(item.name);
      this.ID = item.id;
      this.godina = item.year;
      this.alkohol = item.alcohol;

      this.rezidualni_secer = item.residualSugar;
      this.kiselina = item.totalAcid;

      this.ph = item.ph;
      this.ukupni_sulfati = item.totalSulfates;
      this.opis = item.description;

      this.slobodni_sulfati = item.freeSulfates;

      if (item.wineLabel !== null) {
        this.select = item.wineLabel;
        this.proizvodnja = item.wineLabel.inProduction;
      } else {
        this.select = "";
        this.proizvodnja = false;
      }
    });
  },
};
</script>
    
<style lang="scss" scoped>
// .wineItemComponentForm {
//   max-width: 430px;
// }
.Description textarea {
  height: 40px;
}
</style>
